import * as React from 'react'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'

interface Props {
  vm: JobViewModel
}

export default observer(function ForfeitDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  return (
    <ModalSheet
      showing={vm.forfeitVM.showing}
      onRequestClose={vm.forfeitVM.close}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_forfeit-job.svg')}
              alt="Man crumbling a piece of paper and throwing it away"
            />
          )}
          <ModalSheetContentTitle>
            Are you sure you want to forfeit this job?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Release this job and transfer it back to a pool of appropriate
            professionals.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.forfeitVM.close}
            disabled={vm.forfeitVM.forfeit.pending}
          >
            Close
          </Button>
          <Button
            submit
            loading={vm.forfeitVM.forfeit.pending}
            disabled={vm.forfeitVM.forfeit.pending}
            onClick={vm.forfeitVM.forfeit}
            type="danger"
          >
            Forfeit Job
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
